module.exports = __webpack_public_path__ + "img/img-noise-361x370.0fcfe0dd.png";